import { render, staticRenderFns } from "./GExhibitionEdit.vue?vue&type=template&id=59f14636&scoped=true&"
import script from "./GExhibitionEdit.vue?vue&type=script&lang=ts&"
export * from "./GExhibitionEdit.vue?vue&type=script&lang=ts&"
import style0 from "./GExhibitionEdit.vue?vue&type=style&index=0&id=59f14636&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f14636",
  null
  
)

export default component.exports